/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

export const Container = styled.div`
  overflow: visible;
`;
